// TestMyPage.js
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/utils/Loader';
import useFetch from '../hooks/useFetch';
import MainLayout from '../layouts/MainLayout';
import ShareOnWhatsAppButton from '../components/ShareOnWhatsAppButton';
import '../styles/MessageDisplay.css';
import STT from "../components/STT";

const TestMyPage = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [image, setImage] = useState(null);

  const [preview, setPreview] = useState(null);

  const [formData, setFormData] = useState({
    fromname: '',
    toname: '',
    subject: '',
    messageType: '',
    message: '',
  });


  const [textInput, setTextInput] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState(""); 
  const {startListening, stopListening } = STT({ continous: true });
  const startStopListening = () => {
    isListening ? stopListening() : startListening();
  }

  const handleClick = () => {
    setIsListening(prevIsListening => !prevIsListening); // Toggle isListening state
  };

  const [submitMessage, setSubmitMessage] = useState('');
  let submitstatus = "";

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.toname.trim()) {
      newErrors.toname = 'To Name is required';
      isValid = false;
    }

    if (!formData.subject.trim()) {
      newErrors.subject = 'Subject is required';
      isValid = false;
    }

    if (!formData.messageType) {
      newErrors.messageType = 'Please select an messageType type';
      isValid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
      isValid = false;
    } else if (formData.message.length > 500) {
      newErrors.message = 'Message must be 500 characters or less';
      isValid = false;
    }

    if (!formData.fromname.trim()) {
      newErrors.fromname = 'From Name is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (validateForm()) {
      setFormData({
        fromname: '',
        toname: '',
        subject: '',
        messageType: '',
        message: '',
      });
      setImage(null);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'message') {
      setTextInput(value);
    } else if (name === 'image') {
      const file = files[0]; 
    }
    if (files && files.length > 0) {
      handleFileChange(e);
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile.size > 5 * 1024 * 1024) {
      alert("File size exceeds 5 MB. Please select a smaller file.");
      e.target.value = null;
      return;
    }
    const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
      setImage(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    } else {
      alert('Please select a valid image file (JPG, JPEG, PNG, GIF)');
      e.target.value = null;
      setImage(null);
      setPreview(null);
    }
  };

  const imageUrl = preview;
  const message = formData.message;

  const stopVoiceInput = () => {
    setTextInput(preVal => preVal + (transcript.length ? (preVal.length ? ' ' : '') + transcript : ''))
    stopListening()
  }

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Message Share (Life Chronicle - Invitation, Gratitude, Empathy, Sympathy, Regret, Greeting)</h2>
      </div>
      <div className="message-container">
        <form onSubmit={handleSubmit} className="message-form">
          <label>Message Type*:</label>
          <div className='text-black w-300'>
            <select name="messageType" value={formData.messageType} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="Empathy">Empathy</option>
              <option value="Gratitude">Gratitude</option>
              <option value="Greeting">Greeting</option>
              <option value="Invitation">Invitation</option>
              <option value="Regret">Regret</option>
              <option value="Sympathy">Sympathy</option>
            </select>
            {errors.messageType && <span className="error-message">{errors.messageType}</span>}
          </div>

          <label>Form Name*:</label>
          <input type="text" name="fromname" value={formData.fromname} onChange={handleChange} className="input-field" />
          {errors.fromname && <span className="error-message">{errors.fromname}</span>}

          <label>To Name*:</label>
          <input type="text" name="toname" value={formData.toname} onChange={handleChange} className="input-field" />
          {errors.toname && <span className="error-message">{errors.toname}</span>}

          <label>Subject*:</label>
          <input type="subject" name="subject" value={formData.subject} onChange={handleChange} className="subject-field" style={{ height: '30px' }} />
          {errors.subject && <span className="error-message">{errors.subject}</span>}

          <label>Message*:</label>
          <textarea
            name="message"
            value={isListening ? textInput + (transcript.length ? (textInput.length ? ' ' : '') + transcript : '') : textInput}
            onChange={handleChange}
            maxLength={500}
            disabled={false}
            className="text-area" 
          />
          {errors.message && <span className="error-message">{errors.message}</span>}
          
          <div>
            <button
              type="button"
              className="submit-button w-36"
              onClick={handleClick}
            >
              {isListening ? "Stop" : "Speak"}
            </button>
            <button type="submit" className="submit-button w-36">Rewrite Using AI</button>
          </div>

          <label>Image* (Type - JPG, PNG, GIF, Size - Max 5MB):</label>
          <input
            type="file"
            name="image"
            accept=".jpg, .jpeg, .png, .gif"
            onChange={handleFileChange}
            className="input-file"
          />
          <span className="text-white">You have selected {image && image.name}</span>

          <div className='share-message-conatiner w-fit'>
            {image && (
              <div style={{ marginBottom: '20px' }}>
                <img
                  src={URL.createObjectURL(image)}
                  alt="Uploaded"
                  style={{
                    width: '100%',
                    maxWidth: '256px',
                    height: 'auto',
                    marginBottom: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                  }}
                />
              </div>
            )}
            <div>
              <p
                style={{
                  fontSize: '16px',
                  lineHeight: '1.5',
                  maxWidth: '300px',
                  margin: '0 auto',
                }}
              >
                {formData.message}
              </p>
            </div>
          </div>
          <div>
            <ShareOnWhatsAppButton imageUrl={imageUrl} message={message} />
          </div>

          <div className='button-conatiner w-fit'>
            <button type="submit" className="submit-button w-32">Save</button>
            <button type="submit" className="submit-button w-32">Cancel</button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default TestMyPage;



